import { forwardRef, useEffect } from 'react';
import { TextField } from './TextField';
import { useDebounceValue } from 'usehooks-ts';

type DebouncedFieldProps = {
  value?: string;
  onDebouncedChange: (value: string) => void;
} & React.ComponentPropsWithoutRef<typeof TextField>;

export const DebouncedTextField = forwardRef<HTMLInputElement, DebouncedFieldProps>(
  function DebouncedTextField(
    { value, defaultValue, onDebouncedChange, ...props },
    ref,
  ): React.ReactElement {
    const [debouncedValue, setValue] = useDebounceValue(defaultValue, 500);

    useEffect(() => {
      if (debouncedValue !== undefined) {
        onDebouncedChange(debouncedValue as string);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue]);

    return (
      <TextField
        {...props}
        defaultValue={defaultValue}
        onChange={({ target }) => setValue(target.value)}
        ref={ref}
      />
    );
  },
);
